import { isIsoInstant } from '@/services/allocationPriority/isoInstant'

/** LOGISPRD-14585: 최근 업데이트 시각 빈값. 00:00:00·현재 시각으로 채우지 않는다. */
export const CAPA_UPDATED_EMPTY = '최근 업데이트 —'

const pad2 = (n: number): string => String(n).padStart(2, '0')

/** ISO Instant → `최근 업데이트 YYYY-MM-DD HH:mm:ss`(브라우저 로컬 24h — 컨덕터 데모 표기). 빈값·형식 오류는 CAPA_UPDATED_EMPTY. */
export const formatCapaUpdatedLabel = (fetchedAt: string | null | undefined): string => {
  if (!isIsoInstant(fetchedAt)) return CAPA_UPDATED_EMPTY
  const d = new Date(fetchedAt)
  const ymd = `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
  return `최근 업데이트 ${ymd} ${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`
}
